import { TimelineLite, Linear } from 'gsap'

class LoopElement {
  constructor (selector, duration) {
    this.init = false
    this.timeline = new TimelineLite({ paused: true })
    this.selector = selector
    this.duration = duration
  }

  animate (page) {
    const _page = document.getElementById(page)
    const _element = _page.querySelector(this.selector)
    const _parent = _element.parentNode

    if (_element !== null) {
      const _parentWidth = _parent.offsetWidth
      const _elementWidth = _element.offsetWidth
      const _elementPos = _element.offsetLeft

      // initial tween
      this.timeline.to(_element, this.duration, {
        x: (_parentWidth + _elementWidth),
        ease: Linear.easeNone
      }, 0)

      // loop from opposite edge
      this.timeline.fromTo(_element, this.duration, {
        x: -Math.abs(_elementPos + _elementWidth),
        ease: Linear.easeNone,
        immediateRender: false
      }, {
        x: (_parentWidth + _elementWidth),
        ease: Linear.easeNone,
        repeat: -1
      })

      // this.init = true
      this.timeline.play()
    } else {
      console.log('Animated element doesn\'t exist')
    }
  }

  delete () {
    this.timeline.kill()
  }
}

export { LoopElement }



// WEBPACK FOOTER //
// ./src/classes/LoopElement.js